
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* KEYWORDS: attribution credits image noun project theme */
    }
    <h1>{`Image Attributions`}</h1>
    <p>{`Attributions for assets used on this site under `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by/2.0/"
      }}>{`CC BY`}</a>{`.`}</p>
    <h2>{`St. Patrick's Day Theme`}</h2>
    <ul>
      <li parentName="ul">{`"Four-Leaf Clover" by Alexander Skowalsky from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=Four-Leaf+Clover&i=754313"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Saint Patrick's Day" by Isabel Martínez Isabel from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=Saint+patricks+day&i=125381"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Gold pot" and "Horseshoe" by Nikita Kozin from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/kozinn/collection/saint-patricks-day/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Lucky Coin" by Erin Agnoli from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=lucky+coin&i=1635238"
        }}>{`the Noun Project`}</a>{`.`}</li>
    </ul>
    <h2>{`Earth Day Theme`}</h2>
    <ul>
      <li parentName="ul">{`App Bar icons by Tezar Tantular from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/kerismaker/collection/mother-earth-day-glyph/"
        }}>{`the Noun Project`}</a>{`.`}</li>
    </ul>
    <h2>{`Independence Day Theme`}</h2>
    <ul>
      <li parentName="ul">{`"Eagle" by m. turan ercan from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/term/eagle/1025832/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Firework" by Path Lord from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/term/firework/1759830/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Firework" by Natalya Skidan from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/term/firework/3866800/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Firework" by KonKapp from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/term/firework/4021197/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Uncle Sam Hat" by Nikita Kozin from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=uncle+sam+hat&i=476907"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"American Flag" by P Thanga Vignesh from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=4th+of+july&i=171699"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Statue of Liberty" by Nikita Kozin from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/term/statue-of-liberty/476914/"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`Landing page banner from `}<a parentName="li" {...{
          "href": "https://visitwalworthcounty.wordpress.com/2018/06/"
        }}>{`Visit Walworth County`}</a>{`.`}</li>
    </ul>
    <h2>{`Mid-Autumn Festival Theme`}</h2>
    <ul>
      <li parentName="ul">{`"moon cake" by Template from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=4117811&i=4117811"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Lanterns" by Xinh Studio from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=mid+autumn+festival&i=1253406"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"Rabbit" by Chanut is Industries from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/search/?q=rabbit&i=2077812"
        }}>{`the Noun Project`}</a>{`.`}</li>
      <li parentName="ul">{`"moon cake" by Nattapol Seengern from `}<a parentName="li" {...{
          "href": "https://thenounproject.com/bankseengern/uploads/?i=4091100"
        }}>{`the Noun Project`}</a>{`.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;